module.exports = __webpack_public_path__ + "img/lg_ring_g_0_0_0@2x.f3340e60.png";